import { Text } from '@/components/text';
import { Colors } from '@/constants/theme';
import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import React, { useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import Animated, { FadeInUp, FadeOutUp, LinearTransition } from 'react-native-reanimated';

interface FieldLabelProps {
    label: string;
    description?: string;
    style?: any;
}

export function FieldLabel({ label, description, style }: FieldLabelProps) {
    const [expanded, setExpanded] = useState(false);

    if (!description) {
        return <Text type="defaultSemiBold" style={[styles.label, style]}>{label}</Text>;
    }

    return (
        <View style={[styles.container, style]}>
            <Pressable
                onPress={() => setExpanded(!expanded)}
                style={styles.pressable}
                hitSlop={8}
            >
                <Text type="defaultSemiBold" style={styles.label}>
                    {label}
                </Text>
                <View style={styles.iconContainer}>
                    {/* <MaterialIcons name="info-outline" size={16} color={Colors.light.primary} /> */}
                    <MaterialIcons
                        name={expanded ? 'keyboard-arrow-up' : 'keyboard-arrow-right'}
                        size={22}
                        color={Colors.light.primary}
                    />
                </View>
            </Pressable>

            {expanded && (
                <Animated.View
                    entering={FadeInUp.duration(200)}
                    exiting={FadeOutUp.duration(200)}
                    layout={LinearTransition.springify()}
                >
                    <Text style={styles.description}>
                        {description}
                    </Text>
                </Animated.View>
            )}
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        gap: 4,
        marginBottom: 4,
    },
    pressable: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6,
        alignSelf: 'flex-start',
        paddingVertical: 2,
    },
    label: {
        // Label overrides
    },
    iconContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 0,
    },
    description: {
        fontSize: 14,
        color: 'rgba(0,0,0,0.55)',
        lineHeight: 20,
        marginTop: 2,
        marginBottom: 6,
        paddingLeft: 2, // Minor alignment with label
        fontStyle: 'italic',
    },
});
